<template>
<div class="filelist-wrap">
    <div class="xl-upload" v-for="(file, index) in fileList" :key="index">
        <div class="el-upload-list el-upload-list--picture myfileitem ">
            <div class="el-upload-list__item">
                <div class="xl-upload-file">
                    <div class="xl-upload-file-l">
                    <div class="xl-upload-file-lbg">
                        <span>{{ getFileExt(file?.name) }}</span>
                    </div>
                    <div class="xl-upload-file-c">
                        <div
                        class="xl-upload-file-ct"
                        :style="fileMaxWidth ? 'max-width:' + fileMaxWidth + 'px' : ''"
                        >
                        <div class="file-name">{{ getFileNameWithoutExt(file?.name) }}</div>
                        <div class="file-ext">{{ getFileExt(file?.name) }}</div>
                        </div>
                        <div v-if="file?.status === 'uploading'" class="xl-upload-file-c-progress">
                        <div class="xl-upload-file-c-progress-inner" :style="'width:' + file?.percentage + '%'"></div>
                        </div>
                        <div v-if="file?.status !== 'uploading' && file?.size" class="xl-upload-file-cb">
                        {{ formatFileSize(file?.size) }}
                        </div>
                    </div>
                    </div>
                    <div class="xl-upload-file-r" :class="file?.status ==='success' ? 'is-success' : ''">
                    <div v-if="file?.status ==='success'" class="file-status"></div>
                    <div
                        class="file-clean"
                        @click.stop="upRemove(file, file?.raw)"
                    ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <xl-upload2 
        ref="uploadRef"
        v-model:file-list="ownFileList"
        v-bind="$attrs">
    </xl-upload2>
</div>
</template>

<script>
export default {
    inheritAttrs: false
}
</script>

<script setup>

import { ref, defineProps, useAttrs, computed } from 'vue';
import {
	XlUpload2
} from '@shining3d/ui-components';

const uploadRef = ref(null);
const props = defineProps({
    fileList: Object
});

const $attrs = useAttrs();

const ownFileList = computed({
  get: () => props.fileList,
  set: ( val ) => {
    emits( 'update:file-list', val );
  }
});

const getFileNameWithoutExt = (name) => {
  let n = name || ''
  if (n.includes('.')) {
    n = name.slice(0, name.lastIndexOf('.'))
  }
  return n
}

const getFileExt = (name) => {
  let ext = ''
  if (name.includes('.')) {
    ext = name.slice(name.lastIndexOf('.'), name.length)
  }
  return ext
}

function formatFileSize(fileSize) {
  if (!fileSize) {
    return
  }
  if (fileSize < 1024) {
    return fileSize + 'B'
  } else if (fileSize < 1024 * 1024) {
    let temp = fileSize / 1024
    temp = temp.toFixed(2) 
    return temp + 'KB'
  } else if (fileSize < 1024 * 1024 * 1024) {
    let temp = fileSize / (1024 * 1024)
    temp = temp.toFixed(2) 
    return temp + 'MB'
  } else {
    let temp = fileSize / (1024 * 1024 * 1024)
    temp = temp.toFixed(2) 
    return temp + 'GB'
  }
}

const upRemove = (file, rowFile) => {
    uploadRef.value.handleRemove(file, rowFile)
};

</script>

<style lang="scss" scoped>
.filelist-wrap {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    .xl-upload {
        margin-right: 24px;
        width: 376px;
    }
    .el-upload-list {
        margin-top: 0px !important;
    }
    .el-upload-list__item {
        margin-top: 0px;
        margin-bottom: 20px;
    }
}
</style>